// This will be included in the future release of ABS Customer Portal Shared UI Components

import React, { useCallback, useMemo, useState } from 'react';
import { MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem } from 'mdbreact';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Icon } from 'customer_portal-ui-shared';
import { useLocation } from 'react-router-dom';

const CustomHeader = ({ brandImg, brandName, onBrandClick, menuOptions = [], onMenuItemClick, type = 'main' }) => {
    const [selected, setSelected] = useState('dashboard');
    const location = useLocation();

    const handleBrandClick = () => {
        setSelected('dashboard');
        onBrandClick('dashboard');
    };

    const getSelected = () => {
        if (!location.state) {
            return 'dashboard';
        }

        return location.state.keyName;
    };

    const createNavBarDropDown = useCallback(
        (text, options = []) => {
            const render = [];
            let elements = [];
            let count = 0;
            options.forEach((option) => {
                if (option.type === 'divider ') {
                    elements.push(<MDBDropdownItem divider />);
                }

                count++;
                elements.push(
                    <MDBDropdownItem
                        key={`${option.text} - ${option.value}`}
                        onClick={() => {
                            setSelected(option.text);
                            onMenuItemClick(option.value);
                        }}
                    >
                        {option.text}
                    </MDBDropdownItem>
                );
                if (count % 5 === 0 || count === options.length) {
                    render.push(<div>{elements.map((ele) => ele)}</div>);
                    elements = [];
                }
            });

            return (
                <MDBNavItem
                    className={`${selected === text ? 'selected' : ''}`}
                    onClick={() => {
                        setSelected(text);
                    }}
                >
                    <MDBDropdown>
                        <MDBDropdownToggle nav caret>
                            <span className="mr-2">{text}</span>
                        </MDBDropdownToggle>
                        <MDBDropdownMenu>{render.length ? render : <div>{elements}</div>}</MDBDropdownMenu>
                    </MDBDropdown>
                </MDBNavItem>
            );
        },
        [selected]
    );

    const renderLeftItem = useMemo(() => {
        return (
            <MDBNavbarNav left>
                {menuOptions.map((item) => {
                    if (item.position === 'right') return null;
                    if (item.type?.includes('dropdown')) {
                        return createNavBarDropDown(item.text, item.options);
                    } else if (item.type === 'divider')
                        return (
                            <MDBNavItem className="divider">
                                <div></div>
                            </MDBNavItem>
                        );
                    else
                        return (
                            <MDBNavItem
                                className={`${getSelected() === item.value ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelected(item.value);
                                    onMenuItemClick(item.value);
                                }}
                            >
                                {item.icon ? <Icon icon={item.icon} /> : null}
                                {item.text}
                            </MDBNavItem>
                        );
                })}
            </MDBNavbarNav>
        );
    }, [menuOptions, selected]);

    const renderRightItem = useMemo(() => {
        return (
            <MDBNavbarNav right>
                {menuOptions.map((item) => {
                    if (item.position === 'left') return null;
                    if (item.type === 'dropdown') {
                        return createNavBarDropDown(item.text, item.options);
                    } else if (item.type === 'divider')
                        return (
                            <MDBNavItem className="divider">
                                <div></div>
                            </MDBNavItem>
                        );
                    else
                        return (
                            <MDBNavItem
                                className={`${getSelected() === item.value ? 'selected' : ''}`}
                                onClick={() => {
                                    setSelected(item.value);
                                    onMenuItemClick(item.value);
                                }}
                            >
                                {item.icon ? <Icon icon={item.icon} className="icon" /> : null}
                                {item.text}
                            </MDBNavItem>
                        );
                })}
            </MDBNavbarNav>
        );
    }, [menuOptions, selected]);

    return (
        <StyledNavbar>
            <MDBNavbar className={`${type === 'main' ? 'main' : ''}`}>
                <MDBNavbarBrand onClick={handleBrandClick} className={`${getSelected() === 'dashboard' ? 'selected' : ''}`}>
                    {brandImg ? <img src={brandImg} /> : null}
                    <span>{brandName}</span>
                </MDBNavbarBrand>
                {renderLeftItem}
                {renderRightItem}
            </MDBNavbar>
        </StyledNavbar>
    );
};

CustomHeader.propTypes = {
    brandImg: PropTypes.string,
    brandName: PropTypes.string,
    brandHref: PropTypes.string,
    onBrandClick: PropTypes.func,
    type: PropTypes.string,
    onMenuItemClick: PropTypes.func,
    menuOptions: PropTypes.arrayOf(
        PropTypes.shape({
            position: PropTypes.string.isRequired,
            value: PropTypes.string,
            text: PropTypes.string.isRequired,
            options: PropTypes.arrayOf(
                PropTypes.shape({
                    value: PropTypes.string.isRequired,
                    text: PropTypes.string.isRequired,
                    type: PropTypes.string
                })
            ),
            type: PropTypes.string
        })
    )
};

const StyledNavbar = styled.div`
    .navbar {
        padding: 0;
        background: #dee2e7 0% 0% no-repeat padding-box;
        color: #002a4e;
        .navbar-brand {
            margin-right: 0;
            padding: 15px 25px;
            cursor: pointer;
            & span {
                letter-spacing: 0px;
                font: normal normal bold 13px/16px Montserrat;
            }
            & img {
                width: 112px;
                height: 46px;
            }
        }
        .navbar-brand.selected {
            background-color: #ffffff;
        }
        .navbar-nav {
            display: -webkit-inline-box;
            .nav-item {
                height: 60px;
                display: flex;
                align-items: center;
                padding: 0 15px;
                font: normal normal bold 13px/16px Montserrat;
                cursor: pointer;
                .icon {
                    background-color: red;
                    border-radius: 50%;
                    margin-right: 8px;
                }
                .dropdown {
                    & a {
                        font: normal normal medium 13px/16px Montserrat;
                        letter-spacing: 0px;
                        color: #002a4e;
                        font-weight: bold;
                    }
                    .dropdown-menu {
                        top: 12px !important;
                        left: -16px !important;
                        box-shadow: 0px 3px 7px #00000021;
                        background: #ffffff 0% 0% no-repeat padding-box;
                        border-radius: 0px;
                        .dropdown-item {
                            text-align: left;
                            font: normal normal medium 13px/20px Montserrat;
                            letter-spacing: 0px;
                            color: #231f20;
                            :hover {
                                color: #5e8ab4 !important;
                                background-color: transparent;
                            }
                        }
                    }
                    .dropdown-menu {
                        .popover-enter {
                            display: flex;
                        }
                        .popover-enter-done {
                            display: flex;
                        }
                    }
                }
            }
            .nav-item.divider {
                padding: 0;
                width: 1px;
                & div {
                    border: 1px solid #da1f33;
                    height: 50%;
                }
            }
            .nav-item.selected {
                background: #ffffff 0% 0% no-repeat padding-box;
                box-shadow: 0px -3px 6px #00000045;
            }
        }
    }
    .navbar.main {
        background: #002a4e 0% 0% no-repeat padding-box;
        color: #ffffff;
        font: normal normal bold 12px/15px Montserrat;
        letter-spacing: 0px;
        .navbar-nav .nav-item .dropdown {
            & a {
                font: normal normal bold 12px/15px Montserrat;
                letter-spacing: 0px;
                color: #ffffff;
            }
            .dropdown-menu {
                top: 10px !important;
                box-shadow: 0px 3px 7px #00000021;
                background: #ffffff 0% 0% no-repeat padding-box;
            }
        }
        .navbar-brand.selected,
        .navbar-nav .nav-item.selected {
            background-color: transparent;
        }
    }
`;

export default CustomHeader;
